import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import RefreshIcon from "@material-ui/icons/Refresh";
import ReplayIcon from "@material-ui/icons/Replay";
import ToggleOfIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import React from "react";
import { MenuOptionType } from "../../../../../../controls";
import { Job } from "../../../models/Job";

type Props = {
	setShowModal: (modal: "create" | "update" | "reset" | "enable" | "") => void;
	setJobSelected: (job: Job) => void;
	getJobsFromAPI: Function;
};

export const useJobsOptionsFunctions = ({
	setShowModal,
	setJobSelected,
	getJobsFromAPI,
}: Props) => {
	const getMenuOptions = (data: Job) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Job",
				key: "new_job",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Enable Job",
					key: "enable_job",
					disabled: data.Enabled ? true : false,
					onClick: () => {
						setShowModal("enable");
						setJobSelected(data);
					},
					icon: <ToggleOnIcon />,
				},
				{
					name: "Disable Job",
					key: "disable_job",
					disabled: data.Enabled ? false : true,
					onClick: () => {
						setShowModal("enable");
						setJobSelected(data);
					},
					icon: <ToggleOfIcon />,
				},
				{
					name: "Reset Job",
					key: "reset_job",
					onClick: () => {
						setShowModal("reset");
						setJobSelected(data);
					},
					icon: <ReplayIcon />,
				},
			]);
		}
		options = options.concat([
			{
				name: "Refresh Job",
				key: "refresh_job",
				onClick: () => {
					getJobsFromAPI();
				},
				icon: <RefreshIcon />,
			},
		]);
		return options;
	};
	return {
		getMenuOptions,
	};
};
